<template>
    <div class="listmain ">
        <h1 class="firTitle">推送申请</h1>

              <h3 class="sedTitle">1、概述</h3>
              <p>推送申请是向开发者提供的消息推送功能，开发者向开放平台运营中心提交推送申请需求，运营中心择优选取优秀的内容素材发起消息推送，帮助高质量开发者拉动用户活跃度、内容播放时长，改善产品体验。
              </p>
              <h3 class="sedTitle">2、推送申请介绍</h3>
              <p>（1）申请流程
              </p>
               <p>完成配置并提交申请后，内容会进入开放平台运营中心素材库。运营人员将会择优进行推送，发起推送时将会通过消息中心告知进展。
              </p>
               <p>（2）内容填写规范
              </p>

            <table>
                <tr>
                  <th>字段名称</th>
                  <th>释义</th>
                  <th>是否必填</th>
                  <th>备注</th>
                </tr>
                <tr>
                  <td>推送标题</td>
                  <td>仅用于辨识，不会展示用户侧</td>
                  <td>是</td>
                  <td></td>
                </tr>
                <tr>
                  <td>语音播报文案</td>
                  <td>设备收到推送时播放的TTS文案内容</td>
                  <td>是</td>
                  <td>在用户端会以语音的形式播报出来</td>
                </tr>
                 <tr>
                  <td>推送资源名称</td>
                  <td>设备播报完TTS文案内容后，串接的歌曲/其他音频内容。不填时则无内容串接</td>
                  <td>否</td>
                  <td>仅填写名称即可，猎户运营会根据音频名称获取资源</td>
                </tr>
                 <tr>
                  <td>推送资源url</td>
                  <td>同功能名称</td>
                  <td>否</td>
                  <td>同样为辅助猎户运营查找、定位资源时使用</td>
                </tr>
                 <tr>
                  <td>期望推送时间rl</td>
                  <td>选择期望推送的时间，最长跨度不超过3天</td>
                  <td>是</td>
                  <td>运营根据申请的时间区间，结合内容、全局推送进行实际排期</td>
                </tr>
                  <tr>
                  <td>推送人群</td>
                  <td>描述期望推送的用户画像</td>
                  <td>是</td>
                  <td>可以从用户自然属性（年龄、性别等）、行为属性（喜欢听音乐、喜欢听玄幻小说等）进行描述</td>
                </tr>
          </table>

             <h3 class="thirdTitle">样例：</h3>
             <p>标题<br>
             李宗盛生日歌迷推送
             </p>
              <p>语音播报文案：<br>
             主人，你最喜欢的漂洋过海来看你，更新了，快来一起聆听吧
             </p>
               <p>推送资源名称：<br>
            李宗盛《漂洋过海来看你》
             </p>
      <p>推送资源url：</p>
           <span>https://y.qq.com/n/yqq/song/001UyVOM4bYLSV.html?ADTAG=baiduald&play=1 </span>
             </p>
            <p>期望推送时间：<br>
            2018/7/19～2018/7/19
             </p>
              <p>推送人群：<br>
            19～30岁，性别不限，文艺范，喜欢听老歌
             </p>
               <p>试听<br>
           点击试听按钮，对TTS文案内容进行试听，预览用户真实推送交互场景
             </p>
              <p>（注：审核是否通过除推送申请内容因素外，还受整体排期限制，会存在因排期而无法通过审核的情况）
             </p>





    </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
    font-size: 14px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/xggj_tssq.vue